const ATLAS_PROVIDER = 'atlas';

const STATUS_PRESENTATION = {
  pending_issuance: {
    label: 'Preparing voucher',
    className: 'border-amber-200 bg-amber-50 text-amber-800',
  },
  voucher_issued: {
    label: 'Voucher issued',
    className: 'border-blue-200 bg-blue-50 text-blue-800',
  },
  redemption_code_minted: {
    label: 'Sending code',
    className: 'border-blue-200 bg-blue-50 text-blue-800',
  },
  redemption_code_delivered: {
    label: 'Code sent',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  },
  issuance_failed: {
    label: 'Refunded',
    className: 'border-red-200 bg-red-50 text-red-800',
  },
  active: {
    label: 'Ready to collect',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  },
  collected: {
    label: 'Collected',
    className: 'border-slate-200 bg-slate-100 text-slate-700',
  },
  expired: {
    label: 'Expired',
    className: 'border-red-200 bg-red-50 text-red-800',
  },
};

export const isAtlasWithdrawal = (withdrawal) => (
  withdrawal?.provider?.toLowerCase() === ATLAS_PROVIDER
);

export const isWithdrawalCodeExpired = (withdrawal, now = Date.now()) => {
  const expiry = getWithdrawalExpiry(withdrawal);
  const expiryTime = expiry ? Date.parse(expiry) : Number.NaN;
  return isAtlasWithdrawal(withdrawal)
    && ['redemption_code_minted', 'redemption_code_delivered'].includes(
      withdrawal?.status
    )
    && Number.isFinite(expiryTime)
    && expiryTime <= now;
};

export const canResendAtlasWithdrawalCode = (withdrawal, now = Date.now()) => (
  isWithdrawalCodeExpired(withdrawal, now)
);

export const getWithdrawalStatusPresentation = (status, expired = false) => (
  (expired ? STATUS_PRESENTATION.expired : STATUS_PRESENTATION[status]) || {
    label: status ? status.replaceAll('_', ' ') : 'Processing',
    className: 'border-slate-200 bg-slate-50 text-slate-700',
  }
);

export const getWithdrawalExpiry = (withdrawal) => (
  isAtlasWithdrawal(withdrawal)
    ? withdrawal?.atlas_redemption_code_expires_at
    : withdrawal?.expires_at
);

export const getWithdrawalSuccessMessage = (response) => (
  response?.provider === ATLAS_PROVIDER
    ? 'Atlas voucher created. The redemption code was sent by SMS.'
    : 'Withdrawal reference generated.'
);

export const getAtlasWithdrawalDescription = (status, expired = false) => {
  if (expired) {
    return 'The redemption code has expired. Request a replacement code to continue.';
  }
  if (status === 'redemption_code_delivered') {
    return 'Your redemption code was sent to your registered mobile number.';
  }
  if (status === 'issuance_failed') {
    return 'Atlas could not issue the voucher and the wallet debit was refunded.';
  }
  return 'Your voucher is being prepared. The redemption code will be sent by SMS.';
};

export const getWithdrawalTransactionTitle = (transaction) => (
  transaction?.payment_provider === ATLAS_PROVIDER
    ? 'Atlas Voucher Withdrawal'
    : 'Withdrawal Reference'
);

export const getWithdrawalTransactionDetail = (transaction) => {
  if (transaction?.payment_provider !== ATLAS_PROVIDER) {
    return transaction?.reference_number || '';
  }
  if (transaction?.status === 'completed') {
    return 'Code delivered by SMS';
  }
  if (transaction?.status === 'failed') {
    return 'Voucher issuance failed and the wallet debit was refunded';
  }
  return 'Voucher and SMS delivery processing';
};
